import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  IconButton,
  Alert,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { DialogProps } from "./types";

interface DefaultVideoDialogProps extends DialogProps {
  selectedDeviceType: string;
  onDeviceTypeChange: (value: string) => void;
}

const DefaultVideoDialog: React.FC<DefaultVideoDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  error,
  selectedDeviceType,
  onDeviceTypeChange
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
            Add Default Video
          </Typography>
          <IconButton onClick={() => !loading && onClose()} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error && (
          <div style={{ marginTop: "5px", marginBottom: "16px" }}>
            <Alert severity="error">{error}</Alert>
          </div>
        )}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Device Type</InputLabel>
          <Select
            value={selectedDeviceType}
            onChange={(e) => onDeviceTypeChange(e.target.value)}
            label="Device Type"
            disabled={loading}
          >
            <MenuItem value="1">Tablet</MenuItem>
            <MenuItem value="15600">Terminal</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <CommonButton onClick={() => !loading && onClose()} disabled={loading}>
          Cancel
        </CommonButton>
        <CommonButton
          onClick={onConfirm}
          disabled={loading || !selectedDeviceType}
          isLoading={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Add"}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultVideoDialog;
